import React from "react";
import { Box, useColorMode } from "@chakra-ui/react";

export const Layout = (props) => {
  const { colorMode } = useColorMode();
  const bgColor = { light: "white", dark: "gray.800" };
  const color = { light: "black", dark: "white" };
  const darkThemeEnabled = colorMode !== "light";

  // This is a bit hacky, but settings the body bg color
  // to the gray.800 color. Can't use gray.800 because it
  // isn't in the scope of the CSS available to the body element.
  document.body.style.background = darkThemeEnabled ? "#1A202C" : "white";

  return (
    <Box p={2} backgroundColor={bgColor[colorMode]} color={color[colorMode]}>
      {props.children}
    </Box>
  );
};
